<template>
<div class="mt-4">
    <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field label="Search" v-model="search"></v-text-field>
    </v-toolbar>
    <v-data-table disable-initial-sort :search="search" :headers="headers" :loading="isLoading" class="elevation-1" :rows-per-page-items="[15, 25, 50,]" :items="organisations" item-key="id" align-center style="cursor: pointer">
        <template v-slot:items="props">
            <td class="text-xs-center" @click="routerLink(props.item)">
                <v-img contain style="height: 30px" :src="props.item.logo" />
            </td>
            <td class="text-xs-center" @click="routerLink(props.item)">
                {{props.item.name}}
            </td>
            <td class="text-xs-center" @click="routerLink(props.item)">
                {{props.item.activeServiceAccounts}}
            </td>
            <td class="text-xs-center" @click="changeStatus(props.item)">
                <v-chip v-if="props.item.isLive == true" color="light-green" class="white--text">Live</v-chip>
                <v-chip v-else color="red" class="white--text">Inactive</v-chip>
            </td>
        </template>
    </v-data-table>
</div>
</template>

<script>
import Api from "../services/Api";
export default {
    data() {
        return {
            organisations: [],
            isLoading: false,
            headers: [{
                    text: "Logo",
                    align: "center",
                    value: "logo",
                    sortable: false
                },
                {
                    text: "Name",
                    align: "center",
                    value: "name",
                },
                {
                    text: "Active Service Accounts",
                    align: "center",
                    value: "activeServiceAccounts",
                },
                {
                    text: "Status",
                    align: "center",
                    value: "isLive",
                },
            ],
            search: ''
        }
    },
    created() {
        this.fetchOrganisations()
    },
    methods: {
        fetchOrganisations() {
            this.isLoading = true
            Api()
                .get("/organisationConnection/ispList")
                .then((response) => {
                    this.organisations = response.data;
                    this.isLoading = false

                });
        },
        changeStatus(item) {
            Api()
                .put("/organisationConnection/" + item.id, {
                    isLive: !item.isLive,
                })
                .then((response) => {
                    this.fetchOrganisations();
                });
        },
        routerLink(item) {
            this.$router.push({
                path: "/ispList/" +
                    item.organisationId
            });
        },
    }
}
</script>
